const FlagIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 79">
        <circle id="Ellipse 10" cx="40" cy="40" r="39.5" stroke="#484848" />
        <g id="Mask group">
          <mask
            id="mask0_230_549"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="30"
            y="30"
            width="20"
            height="20"
          >
            <circle id="Ellipse 11" cx="40" cy="40" r="10" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_230_549)">
            <g id="Group 78">
              <rect
                id="Rectangle 20"
                x="27.2727"
                y="27.2727"
                width="24.5455"
                height="12.7273"
                fill="#1970CD"
              />
              <rect
                id="Rectangle 21"
                x="27.2727"
                y="40"
                width="24.5455"
                height="12.7273"
                fill="#FCB813"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FlagIcon;
